import React from 'react';
import { Box, FormControl, MenuItem, Pagination as MUIPagination, Select, Typography, useTheme } from '@mui/material';

const Pagination = ({ page, onPageChange, count, onRowsPerPageChange, rowsPerPage }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media (max-width: 600px)': {
          display: 'block',
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          sx={{
            fontSize: '14px',
            '@media (max-width: 600px)': {
              fontSize: '12px',
            },
          }}
        >
          Row Per Page:
        </Typography>
        <Box>
          <FormControl size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={rowsPerPage}
              onChange={(e) => {
                onRowsPerPageChange(e);
              }}
              defaultValue={5}
              sx={{
                height: '30px',
                width: '65px',
                fontSize: '14px',
                backgroundColor: '#FFFFFF',
                borderRadius: '30px',
                ml: '5px',
                '@media (max-width: 600px)': {
                  fontSize: '12px',
                  width: '55px',
                  ml: '0px',
                },
                '.MuiOutlinedInput-notchedOutline': { border: 0 },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: '0',
                  borderRadius: '30px',
                },
                '& .MuiSvgIcon-root': {
                  color: '#0071E3',
                },
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      <MUIPagination
        page={page}
        count={count}
        onChange={onPageChange}
        color="info"
        sx={{
          mt: '12px',
          color: theme.palette.info.main,
          '@media (max-width: 600px)': {
            whiteSpace: 'nowrap', // Prevent line breaks
            overflowX: 'auto', // Add horizontal scroll if necessary
            maxWidth: '150%', // Ensure the container is as wide as its parent
            width: '150%',
            ml: '-40px',
          },
        }}
      />
    </Box>
  );
};
export default Pagination;
